import React, { useEffect } from "react";
import "materialize-css/dist/css/materialize.min.css";
import "./App.css";
import { Routes, Route, BrowserRouter } from "react-router-dom";
import {
  Wallet,
  Home,
  Login,
  Register,
  Reset,
  StyleGuide,
  Personas,
  Brands,
  Dashboard,
} from "./pages";
import "./styles/styles.scss";
import { PersonasContextProvider } from "./contexts/PersonasContext";
import Sidenav from "./components/Sidenav";

function App() {
  useEffect(() => {
    const M = require("materialize-css");
    M.AutoInit();
  });

  return (
    <div className="App">
      <BrowserRouter>
        <PersonasContextProvider>
          <Sidenav />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/wallet" element={<Wallet />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/reset" element={<Reset />} />
            <Route path="/personas" element={<Personas />} />
            <Route path="/brands" element={<Brands />} />
            <Route path="/styleguide" element={<StyleGuide />} />
          </Routes>
        </PersonasContextProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
